import Tooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'

import styles from './Chip.module.css'

export const Chip = ({ label, tooltip, variant = 'default', tooltipSize = 'default' }) => {
  const className = `${styles.chip} ${variant === 'warning' ? styles.chipWarning : ''}`

  const sizesSx = {
    default: {},
    large: {
      fontSize: '1rem',
      lineHeight: 1.45,
      maxWidth: 420,
      padding: '10px 12px'
    }
  }

  const tooltipSx = sizesSx[tooltipSize] || {}
  const content = (
    <>
      {variant === 'warning' && (
        <i className={`fa fa-exclamation-triangle ${styles.warningIcon}`} />
      )}
      {label}
    </>
  )

  if (tooltip !== null) {
    return (
      <Tooltip
        title={tooltip}
        placement="top"
        arrow
        slotProps={{
          tooltip: {
            sx: tooltipSx
          }
        }}
      >
        <span className={className}>{content}</span>
      </Tooltip>
    )
  }

  return <span className={className}>{content}</span>
}

export const chipPropTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'warning']),
  tooltipSize: PropTypes.oneOf(['default', 'large'])
}

Chip.propTypes = chipPropTypes
